<template>
  <div class="dashboard-page-header">
    <div class="page-header-left-part">
      <!-- <BaseIconButton
        @click="toggleNavbarCollapse"
        size="sm"
        variant="ghost"
        icon="sidebar"
        textHoverColor="content-secondary"
        textColor="content-tertiary"
        class="header-collapse-button"
        v-if="!isNavbarCollapsed"
      />
      <BaseIconButton
        @click="toggleNavbarCollapse"
        size="sm"
        variant="fill"
        icon="sidebar"
        bgColor="background-base-inverse-primary"
        class="header-collapse-button"
        textColor="content-primary-inverse"
        v-else
      /> -->

      <div class="page-header-title">
        <slot name="supertitle">
          <div class="qrw-heading-sm qrw-text-content-base-primary bold">
            <slot name="title">{{ $t(`navbar.${$route.name}`) }}</slot>
          </div>
        </slot>
        <router-link
          tag="div"
          :to="typeof parent === 'object' ? parent : { name: parent }"
          @click="$emit('toParent')"
          class="qrw-label-sm bold page-header-parent"
          v-if="parent"
        >
          <BaseIcon
            icon="arrow-left"
            size="xs"
          />
          <span>{{ parentText || $t(`navbar.${parent}`) }}</span>
        </router-link>
        <div
          tag="div"
          @click="$emit('toParent')"
          class="qrw-label-sm bold page-header-parent"
          v-else-if="parentText && !parent"
        >
          <BaseIcon
            icon="arrow-left"
            size="xs"
          />
          <span>{{ parentText }}</span>
        </div>
        <div
          class="qrw-label-lg v1-grey-7-color"
          v-if="subtitle"
        >
          <slot name="subtitle">
            {{ subtitle }}
          </slot>
        </div>
      </div>
    </div>

    <div class="page-header-actions">
      <slot name="actions"></slot>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    parent: [String, Object],
    parentText: String,
    subparent: Object,
    subtitle: [String, Boolean]
  },
  methods: {
    toggleNavbarCollapse() {
      const newValue = !this.isNavbarCollapsed
      this.$store.commit('ui/setNavbarCollapsed', newValue)

      if (!newValue) {
        window.localStorage.removeItem('navbar_collapsed')
      } else {
        window.localStorage.setItem('navbar_collapsed', Date.now())
      }
    }
  },
  computed: {
    isNavbarCollapsed() {
      return this.$store.state.ui.navbar_collapsed
    }
  }
}
</script>

<style scoped>
.dashboard-page-header {
  width: 100%;

  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  column-gap: 24px;

  /* background: var(--qrw-background-overlay-a80); */

  padding: 16px 32px;

  box-sizing: border-box;

  /* TODO: this shit is disabled because it breaks page z-index hierarchy */
  /* backdrop-filter: blur(var(--qrw-blur-xl)); */
}

.header-collapse-button {
  border-radius: 8px !important;
}

.page-header-title {
  width: 100%;
  color: var(--v1-grey-10-color);
  display: flex;
  flex-direction: column;
  row-gap: 2px;
}

.page-header-left-part {
  display: flex;
  align-items: flex-start;
  column-gap: 8px;
}

.page-header-actions {
  width: fit-content;
  display: flex;
  align-items: center;
}

.page-header-parent {
  display: flex;
  column-gap: 8px;
  color: var(--qrw-content-tertiary);
  cursor: pointer;
}
</style>
